import { DotLabel } from "components/Dot";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { SectionTemplateHeader } from "components/MainSectionTemplate/SectionTemplateHeader";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import React from "react";
import AirportGoogleMap from "./Detail/AirportGoogleMap";
import SmallDetails from "components/SmallDetails/SmallDetails";
import "moment-timezone";
import moment from "moment";

interface AirportDetailSectionProps {
  airport: server.dto.Airport
}

export const AirportDetailSection = (props: AirportDetailSectionProps) => {
  const { airport } = props;

  return <DetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[{
      type: "regular",
      key: "airport",
      title: RESX.Flight.Airport,
      fields: [{
        key: "isActive",
        label: RESX.Flight.IsActive,
        render: () => <DotLabel dotColor={airport.isActive ? serverReference.constants.colors.green : serverReference.constants.colors.red}>
          {airport.isActive ? RESX.Flight.Active : RESX.Flight.Inactive}
        </DotLabel>
      }, {
        key: "name",
        label: RESX.GeneralLabels.Name,
        render: () => <div>{airport.name}</div>
      }, {
        key: "address",
        label: RESX.Address.resxAddress,
        render: () => <div>{airport.cityCountry}</div>
      }, {
        key: "iata",
        label: "IATA",
        isEmpty: !airport.iata,
        render: () => <div>{airport.iata}</div>
      }, {
        key: "icao",
        label: "ICAO",
        isEmpty: !airport.icao,
        render: () => <div>{airport.icao}</div>
      }, {
        key: "faa",
        label: "FAA",
        isEmpty: !airport.faa,
        render: () => <div>{airport.faa}</div>
      }, {
        key: "localTime",
        label: RESX.DateTime.LocalTime,
        render: () => {
          const timeNow = moment.utc().tz(airport.timeZoneRegionName).format("LT");
          return <SmallDetails
            label={timeNow}
            subLabel={airport.timeZoneRegionName}
          />
        }
      }, {
        key: "flightStatId",
        label: "FlightStats Id",
        render: () => <div>{airport.fs}</div>
      }, {
        key: "systemOneId",
        label: "SystemOne Id",
        render: () => <div>{airport.airportId}</div>
      }]
    }, {
      type: "custom",
      key: "airportMaps",
      render: () => <SectionPanel.Panel
        key="airportMaps"
        id="airportMaps"
        header={<SectionTemplateHeader>{RESX.Map.resxMap}</SectionTemplateHeader>}
        collapsible={{
          start: "open",
          uniqueRowId: "airportMaps",
          persist: true,
        }}
      >
        <AirportGoogleMap airport={airport} />
      </SectionPanel.Panel>
    }]}
  />
}